/*=====================================
    CupoyInfiniteScroll

    Author: Ac
    CreateTime: 2019 / 05 / 30
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

/*--------------------------
    Main Component
--------------------------*/
class CupoyInfiniteScroll extends PureComponent {

    static propTypes = {
        data: PropTypes.array.isRequired,
        renderItem: PropTypes.func.isRequired,
        onEndReached: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.observe = this.observe.bind(this);
        this.handleIntersection = this.handleIntersection.bind(this);

        this.state = {
            data: props.data || [],
        };

        this.observer = undefined;
        this.triggerRef = undefined;
        this.isLoaded = false;
    }

    static getDerivedStateFromProps (nextProps, prevState) {

        const data = nextProps.data;
        const prevData = prevState.data;

        if(JSON.stringify(data) !== JSON.stringify(prevData)) {
            return {
                data: [...data],
            };
        }

        return null;
    }

    componentDidUpdate (prevProps, prevState) {
        if(prevState.data !== this.state.data) {
            this.isLoaded = false;
        }
    }

    componentWillUnmount () {
        if(this.observer) {
            this.observer.disconnect();
        }
    }

    observe (ref) {

        if(!ref) {
            return;
        }

        if(!this.observer) {

            this.observer = new IntersectionObserver(entries => {
                const firstEntry = entries[0];
                if (firstEntry.isIntersecting) {
                    this.handleIntersection();
                }
            })

            if(this.triggerRef) {
                this.observer.unobserve(this.triggerRef);
            }

            this.triggerRef = ref;
            this.observer.observe(ref);
        } else {
            if(this.triggerRef) {
                this.observer.unobserve(this.triggerRef);
            }

            this.triggerRef = ref;
            this.observer.observe(ref);
        }
    }

    handleIntersection () {
        if(!this.isLoaded) {
            this.isLoaded = true;
            this.props.onEndReached && this.props.onEndReached();
        }
    }

    render() {

        const {
            renderItem,
        } = this.props;

        const {
            data,
        } = this.state;

        return (
            <>
                {data.map((key, index) => (
                    <React.Fragment key={typeof key !== 'number' && typeof key !== 'string' ? index: key}>
                        {renderItem({ key, index })}
                    </React.Fragment>
                ))}
                <div ref={this.observe} />
            </>
        );
    }
}

/*--------------------------
    Export
--------------------------*/
export default CupoyInfiniteScroll;